module.exports = __webpack_public_path__ + "img/shrines-1-1024.7da4bb37.jpg";